export const loanProductSelectedAction = (state = {}, action) => {
  switch (action.type) {
    case "LOAN_PRODUCT_SELECTED":
      return action.data;

    default:
      return state;
  }
};
